var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg02D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "221px",
    height: "206px",
    viewBox: "0 0 221 206",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.999 0L77.001 0Q77.1975 0 77.393 0.0192563Q77.5885 0.0385126 77.7812 0.0768396Q77.9738 0.115167 78.1618 0.172196Q78.3499 0.229224 78.5313 0.304406Q78.7128 0.379587 78.8861 0.472197Q79.0594 0.564807 79.2227 0.673953Q79.3861 0.783099 79.5379 0.907731Q79.6898 1.03236 79.8287 1.17128Q79.9676 1.3102 80.0923 1.46206Q80.2169 1.61393 80.326 1.77727Q80.4352 1.94062 80.5278 2.11388Q80.6204 2.28715 80.6956 2.46865Q80.7708 2.65015 80.8278 2.83815Q80.8848 3.02615 80.9231 3.21883Q80.9615 3.41152 80.9807 3.60703Q81 3.80254 81 3.999L81 77.001Q81 77.1975 80.9807 77.393Q80.9615 77.5885 80.9231 77.7812Q80.8848 77.9738 80.8278 78.1618Q80.7708 78.3499 80.6956 78.5313Q80.6204 78.7128 80.5278 78.8861Q80.4352 79.0594 80.326 79.2227Q80.2169 79.3861 80.0923 79.5379Q79.9676 79.6898 79.8287 79.8287Q79.6898 79.9676 79.5379 80.0923Q79.3861 80.2169 79.2227 80.326Q79.0594 80.4352 78.8861 80.5278Q78.7128 80.6204 78.5313 80.6956Q78.3498 80.7708 78.1618 80.8278Q77.9738 80.8848 77.7812 80.9231Q77.5885 80.9615 77.393 80.9807Q77.1975 81 77.001 81L3.999 81Q3.80254 81 3.60703 80.9807Q3.41152 80.9615 3.21883 80.9231Q3.02615 80.8848 2.83815 80.8278Q2.65015 80.7708 2.46865 80.6956Q2.28715 80.6204 2.11388 80.5278Q1.94062 80.4352 1.77727 80.326Q1.61393 80.2169 1.46206 80.0923Q1.3102 79.9676 1.17128 79.8287Q1.03236 79.6898 0.907731 79.5379Q0.783099 79.3861 0.673953 79.2227Q0.564807 79.0594 0.472197 78.8861Q0.379587 78.7128 0.304406 78.5313Q0.229224 78.3498 0.172196 78.1618Q0.115167 77.9738 0.0768396 77.7812Q0.0385126 77.5885 0.0192563 77.393Q0 77.1975 0 77.001L0 3.999Q0 3.80254 0.0192563 3.60703Q0.0385126 3.41152 0.0768396 3.21883Q0.115167 3.02615 0.172196 2.83815Q0.229224 2.65015 0.304406 2.46865Q0.379587 2.28715 0.472197 2.11388Q0.564807 1.94062 0.673953 1.77727Q0.783099 1.61393 0.907731 1.46206Q1.03236 1.3102 1.17128 1.17128Q1.3102 1.03236 1.46206 0.907731Q1.61393 0.783099 1.77727 0.673953Q1.94062 0.564807 2.11388 0.472197Q2.28715 0.379587 2.46865 0.304406Q2.65015 0.229224 2.83815 0.172196Q3.02615 0.115167 3.21883 0.0768396Q3.41152 0.0385126 3.60703 0.0192563Q3.80254 0 3.999 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 180C139.706 180 180 139.706 180 90C180 40.2944 139.706 0 90 0C40.2944 0 0 40.2944 0 90C0 139.706 40.2944 180 90 180Z",
    id: "path_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5 169C133.407 169 169 133.407 169 89.5C169 45.5934 133.407 10 89.5 10C45.5934 10 10 45.5934 10 89.5C10 133.407 45.5934 169 89.5 169Z",
    id: "path_3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PartlyCloudyDay",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-68"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1",
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.011764706,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(14 25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sun--big",
    transform: "translate(17 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-1-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2",
    fill: "none",
    stroke: "#FFF308",
    strokeOpacity: 0.2,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Oval-1-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_2)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_3",
    fill: "none",
    stroke: "#FFF308",
    strokeOpacity: 0.6,
    strokeWidth: 8
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M89.5 157C126.779 157 157 126.779 157 89.5C157 52.2208 126.779 22 89.5 22C52.2208 22 22 52.2208 22 89.5C22 126.779 52.2208 157 89.5 157Z",
    id: "Oval-1",
    fill: "#FFEC65",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud--mini",
    transform: "translate(134 35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5671 43L15.6 43C6.98436 43 0 36.2359 0 27.8919C0 19.5479 6.98436 12.7838 15.6 12.7838C18.1999 12.7838 20.6513 13.3998 22.807 14.4892C25.8087 6.05735 34.0739 0 43.8 0C56.0607 0 66 9.62588 66 21.5C66 21.7434 65.9958 21.9858 65.9875 22.2272C69.5666 24.0894 72 27.7492 72 31.9595C72 38.057 66.896 43 60.6 43L43.8 43C43.7883 43 43.7766 43 43.7649 43C43.765 43 43.765 43 43.765 43L43.5671 43L43.8 43L43.5671 43Z",
    id: "Oval-4-Copy-6",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud--mini",
    transform: "translate(0 113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5671 43L15.6 43C6.98436 43 0 36.2359 0 27.8919C0 19.5479 6.98436 12.7838 15.6 12.7838C18.1999 12.7838 20.6513 13.3998 22.807 14.4892C25.8087 6.05735 34.0739 0 43.8 0C56.0607 0 66 9.62588 66 21.5C66 21.7434 65.9958 21.9858 65.9875 22.2272C69.5666 24.0894 72 27.7492 72 31.9595C72 38.057 66.896 43 60.6 43L43.8 43C43.7883 43 43.7766 43 43.7649 43C43.765 43 43.765 43 43.765 43L43.5671 43L43.8 43L43.5671 43Z",
    id: "Oval-4-Copy-6",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud--mini",
    transform: "translate(29 17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5671 43L15.6 43C6.98436 43 0 36.2359 0 27.8919C0 19.5479 6.98436 12.7838 15.6 12.7838C18.1999 12.7838 20.6513 13.3998 22.807 14.4892C25.8087 6.05735 34.0739 0 43.8 0C56.0607 0 66 9.62588 66 21.5C66 21.7434 65.9958 21.9858 65.9875 22.2272C69.5666 24.0894 72 27.7492 72 31.9595C72 38.057 66.896 43 60.6 43L43.8 43C43.7883 43 43.7766 43 43.7649 43C43.765 43 43.765 43 43.765 43L43.5671 43L43.8 43L43.5671 43Z",
    id: "Oval-4-Copy-6",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02D);
export default __webpack_public_path__ + "static/media/02d.b897203ab930461601ce047096145ded.svg";
export { ForwardRef as ReactComponent };